import React from "react";
import { motion } from "framer-motion";

const tourDates = [
  { date: "Aug 20, 2025", venue: "Madison Square Garden, New York", tickets: "#" },
  { date: "Sep 5, 2025", venue: "O2 Arena, London", tickets: "#" },
  { date: "Sep 25, 2025", venue: "Tokyo Dome, Japan", tickets: "#" },
  { date: "Oct 10, 2025", venue: "Mercedes-Benz Arena, Berlin", tickets: "#" },
  { date: "Nov 3, 2025", venue: "Rod Laver Arena, Melbourne", tickets: "#" },
];

export const TourPage = () => {
  return (
    <><div className="bg-black text-white min-h-screen p-6">
          {/* Header Section */}
          <motion.div
              className="text-center mb-12"
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
          >
              <h1 className="text-5xl font-extrabold uppercase tracking-wide text-primary">
                  Tour Dates
              </h1>
              <p className="text-lg text-gray-300 mt-2">
                  Experience the magic live! Secure your tickets now.
              </p>
          </motion.div>
           {/* Header Section */}
           <motion.div
                  className="text-center"
                  initial={{ opacity: 0, y: -50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1 }}
              >
                 
                  <p className="text-lg text-gray-300 ">
                      No upcoming tours available. Stay tuned!
                  </p>
              </motion.div>

          {/* Tour List 
          <div className="max-w-4xl mx-auto">
              {tourDates.map((tour, index) => (
                  <motion.div
                      key={index}
                      className="bg-gray-900 rounded-lg shadow-lg p-6 mb-6 flex flex-col md:flex-row items-center justify-between"
                      initial={{ opacity: 0, y: 50 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 1, delay: index * 0.2 }}
                  >
                      <div>
                          <h2 className="text-2xl font-bold">{tour.date}</h2>
                          <p className="text-gray-400">{tour.venue}</p>
                      </div>
                      <motion.a
                          href={tour.tickets}
                          className="mt-4 md:mt-0 bg-red-600 hover:bg-red-500 text-white font-semibold px-6 py-2 rounded-lg transition duration-300"
                          whileHover={{ scale: 1.1 }}
                      >
                          Get Ticket 🎟️
                      </motion.a>
                  </motion.div>
              ))}
          </div>

          */}
      </div><div className="bg-black text-white min-h-screen flex flex-col items-center justify-center p-6">
             

              {/* No Tours Available Section */}
              {tourDates.length === 0 && (
                  <motion.div
                      className="mt-10 text-center bg-gray-900 rounded-lg p-8 shadow-lg max-w-lg"
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 1, delay: 0.3 }}
                  >
                      <p className="text-2xl font-semibold">🚨 No Upcoming Tours 🚨</p>
                      <p className="text-gray-400 mt-2">
                          Sign up for notifications to be the first to know!
                      </p>
                      <motion.button
                          className="mt-5 bg-red-600 hover:bg-red-500 text-white font-semibold px-6 py-2 rounded-lg transition duration-300"
                          whileHover={{ scale: 1.1 }}
                      >
                          Notify Me 🔔
                      </motion.button>
                  </motion.div>
              )}
          </div></>
  );
};

export default TourPage;
